/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Tlm_2Inputs */

const en_svc_ai_image_pod_automation_tlm_2 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`storefronts`)
};

const ar_svc_ai_image_pod_automation_tlm_2 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المتاجر`)
};

const bn_svc_ai_image_pod_automation_tlm_2 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্টোর`)
};

const de_svc_ai_image_pod_automation_tlm_2 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefronts`)
};

const es_svc_ai_image_pod_automation_tlm_2 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiendas`)
};

const fr_svc_ai_image_pod_automation_tlm_2 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boutiques`)
};

const pt_svc_ai_image_pod_automation_tlm_2 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lojas`)
};

const zh_svc_ai_image_pod_automation_tlm_2 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`店铺`)
};

const tr_svc_ai_image_pod_automation_tlm_2 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağazalar`)
};

const ru_svc_ai_image_pod_automation_tlm_2 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазины`)
};

const pl_svc_ai_image_pod_automation_tlm_2 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklepy`)
};

/**
* | output |
* | --- |
* | "storefronts" |
*
* @param {Svc_Ai_Image_Pod_Automation_Tlm_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_tlm_2 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Tlm_2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Tlm_2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_tlm_2(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_tlm_2(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_tlm_2(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_tlm_2(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_tlm_2(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_tlm_2(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_tlm_2(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_tlm_2(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_tlm_2(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_tlm_2(inputs)
	return en_svc_ai_image_pod_automation_tlm_2(inputs)
});
export { svc_ai_image_pod_automation_tlm_2 as "svc_ai-image-pod-automation_tlm_2" }